import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "relative",
  ref: "imgHolder"
}
const _hoisted_2 = {
  id: "for-image-vertical-centering",
  class: "h-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  id: "vertical-centering-element",
  class: "inline-block align-middle h-full"
}, null, -1)
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FigureCaption = _resolveComponent("FigureCaption")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(), _createElementBlock("img", {
        class: "inline-block max-h-full",
        style: _normalizeStyle(_ctx.isLoaded ? '' : { height: _ctx.loadingHeight + 'px' }),
        key: _ctx.imageUrl,
        src: _ctx.imageUrl,
        alt: _ctx.imageDescription,
        onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isLoaded = true)),
        onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isError = true))
      }, null, 44, _hoisted_4))
    ]),
    _createVNode(_component_FigureCaption, {
      imageCaption: _ctx.imageCaption,
      imageCaptionLink: _ctx.imageCaptionLink,
      largeCaption: _ctx.largeCaption
    }, null, 8, ["imageCaption", "imageCaptionLink", "largeCaption"]),
    (!_ctx.isLoaded && !_ctx.isError)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
          key: 0,
          class: "absolute top-1/2 left-1/2 z-10"
        }))
      : _createCommentVNode("", true)
  ], 512))
}